// extracted by mini-css-extract-plugin
export var artPostGridItem = "ArtPostsListing-module--art-post-grid-item--Me6X1";
export var postDescription = "ArtPostsListing-module--post-description--JIjKS";
export var postDetails = "ArtPostsListing-module--post-details--odPZR";
export var postMetaWrap = "ArtPostsListing-module--post-meta-wrap--jIKqH";
export var postReadMore = "ArtPostsListing-module--post-read-more--l9lce";
export var postSubtitle = "ArtPostsListing-module--post-subtitle---42Uj";
export var postThumbnail = "ArtPostsListing-module--post-thumbnail--zDs69";
export var postTitle = "ArtPostsListing-module--post-title--e+ffo";